module.exports = __webpack_public_path__ + "aa7e4c55e08ff0b6b69b49d2c1f91754.svg";